import {API_URL} from '../constants/constants'
import {IOrdPerson} from '../types/types'
import {toast} from 'react-toastify'

export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
    const token = localStorage.getItem('accessToken')
    const headers = new Headers(options.headers)

    if (token) {
        headers.set('Authorization', `Bearer ${token}`)
    }

    const response = await fetch(url, {...options, headers})

    if (response.status === 401) {
        localStorage.removeItem('accessToken')
        window.location.reload()
    }

    return response
}

export const api = {
    async getPersons(): Promise<IOrdPerson[]> {
        const toastId = toast.loading('Идет загрузка клиентов')
        const response = await authFetch(`${API_URL}/ord/persons`)
        if (!response.ok) {
            const error = await response.json().catch(() => ({}))
            toast.update(toastId, {
                render: error.message || 'Ошибка загрузки клиентов',
                type: 'error',
                isLoading: false,
                autoClose: 5000
            })
            throw new Error(error.message || 'Ошибка загрузки клиентов')
        }
        toast.update(toastId, {render: 'Клиенты загружены', type: 'success', isLoading: false, autoClose: 5000})
        return response.json()
    }

}
